import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { BUTTON_TYPES, UI_SHAPE } from '@savgroup-front-common/constants';
import { AvatarUser } from '@savgroup-front-common/core/components/AvatarUser/AvatarUser';
import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';
import { NewReversLogoIcon } from '@savgroup-front-common/core/protons/icons';

import {
  $Header,
  $ProfilButton,
  $ProfilButtonContainer,
} from './Header.styles';
import HeaderProfileMenu from './HeaderProfileMenu';

const Header = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();

  const navigate = useNavigate();
  const { firstname, lastname } = useCurrentUser();

  const handleIsOpen = useCallback((value: boolean) => {
    setIsOpen(value);
  }, []);

  return (
    <$Header>
      <button
        type={BUTTON_TYPES.BUTTON}
        onClick={() => navigate('/', { replace: true })}
      >
        <NewReversLogoIcon dotColor={theme.newUI.defaultColors.primary} />
      </button>
      <$ProfilButtonContainer ref={wrapperRef}>
        <$ProfilButton
          onClick={() => handleIsOpen(!isOpen)}
          type={BUTTON_TYPES.BUTTON}
        >
          <AvatarUser
            isHeader
            shape={UI_SHAPE.SQUARE}
            fullName={`${firstname} ${lastname}`}
          />
        </$ProfilButton>
        <HeaderProfileMenu
          onClose={() => handleIsOpen(false)}
          wrapperRef={wrapperRef}
          isOpen={isOpen}
        />
      </$ProfilButtonContainer>
    </$Header>
  );
};

export default Header;
